(function () {
  const INSTANCES = new Map();

  function prefersReducedMotion() {
    return window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches;
  }

  function buildInstance(root) {
    const jsonEl = root.querySelector("[data-splide-options]");
    if (!jsonEl) return null;

    let options = {};
    try {
      options = JSON.parse(jsonEl.textContent);
    } catch (e) {
      console.warn("Splide options JSON invalid", e);
      return null;
    }

    if (prefersReducedMotion()) {
      if (options.autoScroll) delete options.autoScroll;
    }

    const splide = new Splide(root, options);
    const extensions = (window.splide && window.splide.Extensions) ? window.splide.Extensions : null;

    if (extensions && options.autoScroll) splide.mount(extensions);
    else splide.mount();

    return splide;
  }

  function mount(root) {
    if (!root || INSTANCES.has(root)) return;

    const mountMode = root.getAttribute("data-mount-mode") || "both";
    const mql = window.matchMedia("(min-width: 750px)");

    const onChange = () => doMount();

    const doMount = () => {
      const isDesktop = mql.matches;
      const shouldMount =
        mountMode === "both" ||
        (mountMode === "desktop" && isDesktop) ||
        (mountMode === "mobile" && !isDesktop);

      const existing = INSTANCES.get(root);

      if (shouldMount && (!existing || !existing.instance)) {
        const instance = buildInstance(root);
        INSTANCES.set(root, { instance, mql, mountMode, onChange });
      } else if (!shouldMount && existing?.instance) {
        existing.instance.destroy(true);
        INSTANCES.set(root, { instance: null, mql, mountMode, onChange });
      }
    };

    doMount();
    mql.addEventListener("change", onChange);

    if (!INSTANCES.has(root)) {
      INSTANCES.set(root, { instance: null, mql, mountMode, onChange });
    }
  }

  function unmount(root) {
    const data = INSTANCES.get(root);
    if (!data) return;

    try {
      if (data.instance) data.instance.destroy(true);
      if (data.mql && data.onChange) data.mql.removeEventListener("change", data.onChange);
    } finally {
      INSTANCES.delete(root);
    }
  }

  function initAll(container) {
    (container || document).querySelectorAll("[data-bd-splide-featured-collection]").forEach(mount);
  }

  document.addEventListener("DOMContentLoaded", () => initAll(document));
  document.addEventListener("shopify:section:load", (e) => initAll(e.target));
  document.addEventListener("shopify:section:unload", (e) => {
    e.target.querySelectorAll("[data-bd-splide-featured-collection]").forEach(unmount);
  });

  // ✅ NEW: run after recommendations inject HTML
  document.addEventListener("bd:splide:refresh", (e) => {
    initAll(e.detail?.container || document);
  });
})();
